import { AdminUiConfig } from '@vendure/common/lib/shared-types'

// Extend the AdminUiConfig interface to include baseUrl
interface ExtendedAdminUiConfig extends AdminUiConfig {
  baseUrl?: string
}

let vendureUiConfig: ExtendedAdminUiConfig | undefined

export async function loadAppConfig(): Promise<void> {
  vendureUiConfig = await fetch('./vendure-ui-config.json').then((res) =>
    res.json()
  )
}

export function getAppConfig(): ExtendedAdminUiConfig {
  if (!vendureUiConfig) {
    throw new Error(`vendure ui config not loaded`)
  }
  return vendureUiConfig
}
